module.exports = __webpack_public_path__ + "static/media/poster-generic.a512cdd4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/poster-generic.jpeg
// module id = 515
// module chunks = 0